import { CaseStatusEnum } from '@@api/generated/enums';

export const noMapTrackStatuses = [
  CaseStatusEnum.Arrival,
  CaseStatusEnum.Completed,
  CaseStatusEnum.Loaded,
  CaseStatusEnum.Cancelled,
];
